import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IOrderReturn } from '../models/models'

export class OrderReturnStateChangeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReturn/orderReturnStateChange',
      requesterInfo,
    })
  }

  public async orderReturnStateChange(request: IOrderReturn): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
